<template>
  <div>
    <v-layout row class="ml-4 mt-4">
      <div :class="ui.textHeadline"> besea </div>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm6 lg4 offset-sm3 offset-lg4>
        <v-card>
          <v-img
          class="white--text"
          height="200px"
          :src="require('@/app/assets/images/plant02.jpg')"
          >
           <v-container fill-height fluid>
             <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span :class="ui.textHeadline"> unauthorised access </span>
               </v-flex>
             </v-layout>
           </v-container>
         </v-img>
         <v-layout row>
         <v-spacer/>
           <div :class="ui.textImage"> Diavik Mine, Rio Tinto </div>
         </v-layout>
         <v-card-title primary-title>
           <div :class="ui.textTitleError">
             <div class="ml-3">
               Unknown User
             </div>
            </div>
           <div :class="ui.textDescription">
             <div class="ml-3 mt-2">
               Please try to sign in again. If the system stopped unexpectedly, please report the event to your System Admin or to contact@bease.com.au. 
             </div>
           </div>
        </v-card-title>
        <v-layout row>
          <v-btn flat :color="ui.btnColor" :to="'/'">
            <v-icon left> home </v-icon>
            home
           </v-btn>
          <v-spacer/>
          <v-btn flat :color="ui.btnColor" :to="'/signin'">
            <v-icon left> account_circle </v-icon>
            sign in
           </v-btn>
         </v-layout>
         <v-layout row class="mt-4">
           <PublicFooterCard :data="{bkgd: 'white'}"/>
         </v-layout>
       </v-card>
      </v-flex>
    </v-layout>
    </v-container>
    <AppNavigationBottom/>
  </div>
</template>

<script>
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import PublicFooterCard from "@/public/components/PublicFooterCard";

export default {
  components: {
    AppNavigationBottom,
    PublicFooterCard
  },
  mixins: [apptheme],
  data: () => ({})
};
</script>
